import { Dialog, DialogActions, DialogContent } from '@mui/material';
import { styled, Theme } from '@mui/material/styles';
import { Button, IconButton, LoadingButton } from '@components/atoms/Button';
import { Text } from '@/components/atoms/text';

const basePadding = (theme: Theme) => ({
  padding: theme.spacing(2, 3),
});

export const StyledDialog = styled(Dialog)(() => ({
  maxWidth: '100vw',
  zIndex: 1059,
  '& .MuiDialog-paper': {
    maxWidth: 'fit-content',
    maxHeight: 'calc(100% - 50px)',
  },
}));

export const StyledDialogHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  ...basePadding(theme),
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.action.active,
}));

export const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  width: '100%',
  minWidth: '748px',
  height: 'fit-content',
  padding: theme.spacing(3),
  fontSize: 0,
  overflowX: 'hidden',

  [theme.breakpoints.down('md')]: {
    minWidth: '80vw',
  },
}));

export const Title = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  ...basePadding(theme),
  justifyContent: 'space-between',
}));

export const DialogButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  width: '100%',
  gap: theme.spacing(2),
}));

export const CancelButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: '44px',
  color: theme.palette.text.primary,
  textTransform: 'none',
}));

export const SubmitButton = styled(LoadingButton)(({ theme }) => ({
  width: '100%',
  height: '44px',
  textTransform: 'none',
  color: theme.palette.text.primary,
}));
1;
